export const BUSINESSES = '/businesses';
export const PLANS = '/plans';
export const CONTACT = '/contact';
